import { NgModule } from '@angular/core';

@NgModule({
  providers: [],
  imports: [],
})
export class SystemConfigDomainLayerModule {}
